


























































import { Component, Mixins, Prop, Watch } from 'vue-property-decorator'
import { find, forEach, isString, map, sortBy } from 'lodash'
import { Circuit } from '@/interfaces'
import CircuitExerciseList from '@/components/CircuitExerciseList.vue'
import AdminEditMixin from '@/mixins/AdminEditMixin'

@Component({
  components: { CircuitExerciseList }
})
export default class AdminEditCircuit extends Mixins(AdminEditMixin) {
  @Prop({ default: '' }) circuitId!: string

  selected: Circuit|null = null
  selectedExercises = []

  mounted () {
    this.selected = find(this.sortedCicruits, { id: this.circuitId }) || null

    if (this.selected && !this.selected.exercises) {
      this.selected.exercises = []
    }
  }

  get sortedCicruits (): Circuit[] {
    return sortBy(this.$store.getters['circuits/all'], 'name.en')
  }

  addCircuit () {
    this.selected = {
      id: '',
      description: { en: '' },
      exercises: [],
      name: { en: '' }
    }
  }

  async removeCircuit (circuit: Circuit) {
    try {
      await this.$store.dispatch('circuits/removeBase', circuit)

      this.selected = null
    } catch (error) {
      // TODO: display some kind of useful error message
    } finally {
      this.hideConfirmRemoveDialog()
    }
  }

  saveCircuit (circuit: Circuit) {
    // forEach(circuit.exercises, exercise => {
    //   if (isString(exercise.repetitions)) {
    //     exercise.repetitions = exercise.repetitions.split(',').map(Number)
    //   }
    // })

    this.$store.dispatch('circuits/saveBase', circuit)
  }

  setActive (circuit: Circuit) {
    this.selected = circuit
    this.$router.push({ name: 'admin-edit-circuit', params: { circuitId: circuit.id } })
  }
}
